import { defineStore } from 'pinia'
import { ref } from 'vue'
import { $t } from '@previo/core'
import { toast } from '@previo/design-system'
import { StoreKey } from '~/store/StoreKey'
import { Property } from '~/components/switch-property/store/model/Property'
import type { PropertyListResponse } from '~/components/switch-property/http/types'
import { usePropertySuggestAPI } from '~/components/switch-property/http/PropertySuggestAPI'

const propertySuggestAPI = usePropertySuggestAPI()

export const useSwitchPropertyStore = defineStore(StoreKey.SWITCH_PROPERTY, () => {
  const properties = ref<Property[]>([])
  const loading = ref<boolean>(false)

  const search = (search: null | string = null) => {
    loading.value = true

    return new Promise<void>((resolve) => {
      propertySuggestAPI
        .suggestProperties(search)
        .then((r: PropertyListResponse) => {
          properties.value = r
          resolve()
        })
        .catch(() => {
          toast.warning($t('Unable to load properties'))
        })
        .finally(() => {
          loading.value = false
        })
    })
  }

  return {
    properties,
    search,
    loading,
  }
})
